import { Skeleton } from '@mui/material';
import { COLORS, borderRadiusSm } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';
import { css } from 'styled-components';

export const MODEL_CARD_CONTAINER_HEIGHT = 250;
export const MODEL_CARD_CONTAINER_WIDTH = 300;

interface StyledProps {
  opacityIndex: number;
  opacityCoefficient: number;
  imageLoaded: boolean;
}

export const Container = styled.div`
  border: 1px solid ${COLORS.BORDER};
  border-radius: ${borderRadiusSm};
  width: ${MODEL_CARD_CONTAINER_WIDTH}rem;
  height: ${MODEL_CARD_CONTAINER_HEIGHT}rem;
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  ${(props: StyledProps) =>
    props.opacityIndex !== undefined &&
    css`
      opacity: ${1 - (props.opacityIndex * props.opacityCoefficient + 0.2)};
    `}

  ${respondTo.smallLaptop`
    max-width: 300rem;
    width: 100%;
    height: 315rem;
  `}

  ${respondTo.horizontalTablet`
    max-width: 100%;
  `}

  ${respondTo.bigPhone`
    max-width: 100%;
    height: auto;
    margin-bottom: 20rem;
  `}
`;

export const NameLabel = styled.label`
  line-height: 32rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  ${respondTo.smallLaptop`
    line-height: 28rem;
  `}
`;

export const RowCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8rem;
  padding: 0 10rem;
  margin-top: 5rem;
`;

export const StyledSkeleton = styled(Skeleton)`
  border-radius: ${borderRadiusSm};
  margin-bottom: 10rem;
  align-self: center;
`;
